












































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import BaseTextTabs from 'vuecomponents/base_text_tabs.vue'
import PadletList from 'vuecomponents/padlet_list.vue'
import OzLoadingSpinner from 'library/v4/components/OzLoadingSpinner.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import { WallCamelCase as Wall, AccountKey } from 'types'
import { CollectionKey } from 'types/collections'

export interface PadletPickerTabData {
  text: string
  accountKey: AccountKey
  collectionKey: CollectionKey
}

const wallCollectionsStore = namespace('wallCollections')

@Component({ components: { BaseTextTabs, PadletList, OzLoadingSpinner, OzTextButton } })
export default class SurfacePadletPicker extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme

  @Prop({ required: true }) filterTabs!: PadletPickerTabData[]
  @Prop({ required: true }) activeFilterIndex!: number
  @Prop({ default: true }) isPadletListScrollable!: boolean

  @wallCollectionsStore.Getter activeCollectionWalls!: Wall[]
  @wallCollectionsStore.Getter isActiveCollectionFetching!: boolean | null
  @wallCollectionsStore.Getter isActiveCollectionFetchErrored!: boolean | null

  @wallCollectionsStore.Action setAccountCollectionCursor!: ({
    collectionKey,
    accountKey,
  }: {
    collectionKey: CollectionKey
    accountKey: AccountKey
  }) => void
  @wallCollectionsStore.Action fetchActiveCollectionWallsNow!: () => Promise<void>

  isFilterSelected(filterIndex: number): boolean {
    return filterIndex === this.activeFilterIndex
  }

  selectFilter(filterIndex: number): void {
    this.$emit('select-filter', filterIndex)
  }

  selectWall(wall: Wall): void {
    this.$emit('select-wall', wall)
  }

  @Watch('activeFilterIndex', { immediate: true })
  fetchNewWallsByFilter(newActiveFilterIndex: number): void {
    const filter = this.filterTabs[newActiveFilterIndex]
    const { collectionKey, accountKey } = filter
    this.setAccountCollectionCursor({ collectionKey, accountKey })
    this.fetchActiveCollectionWallsNow()
  }
}
